'use client';

import Link from 'next/link';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import BrandLogo from '@/fo/icons/base/icons/logo.svg';
import { UiModHeadFixed } from '@/fo/ui/mod/head/fixed';

import { styles } from './UiAppHeaderCheckout.styles';

export function UiAppHeaderCheckout() {
  const slots = styles();

  return (
    <UiModHeadFixed
      className={slots.top()}
      order={0}
    >
      <div className={slots.container()}>
        <Link
          href={'/catalog?openCart=1'}
          className={slots.topLeftLink()}
        >
          <ChevronIcon className={slots.linkArrow()} />
        </Link>

        <div className={slots.topLogo()}>
          <Link
            href={'/'}
            className={slots.logoBrand()}
          >
            <BrandLogo />
          </Link>
        </div>
      </div>
    </UiModHeadFixed>
  );
}
